export default __webpack_public_path__ + "static/media/Dis_PrintCheque.1c3553ef.svg";